<template>
  <div class="page">
    <div class="box f v fvc">
      <img src="https://j.weizan.cn/youxiang/check-failed.png" class="status-img" />

      <div class="tip">二维码已失效</div>
    </div>

    <div class="f v fvc">
      <div class="back-btn" @click="backHome">返回首页</div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$initWXSDK(null, () => {
      wx.hideAllNonBaseMenuItem();
    });
  },
  methods: {
    backHome() {
      let tmp = localStorage.getItem("preheatPath") || "prehddd";
      this.$router.push({
        path: tmp,
        query: {
          act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  height: 100vh;
  background: #f5f6f7;
  .box {
    padding-bottom: 80px;
    .tip {
      font-size: 14px;
    }
  }
  .back-btn {
    width: 133px;
    height: 44px;
    border: 1px solid rgba(0, 48, 120, 1);
    border-radius: 22px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(0, 48, 120, 1);
    line-height: 44px;
    text-align: center;
    position: fixed;
    bottom: 25px;
  }
  .status-img {
    width: 88px;
    height: 88px;
    margin: 80px 0 20px;
  }
}
</style>